import type { ComboboxItem, ComboboxParsedItem, OptionsFilter } from "@mantine/core";

// Pretraga u padajućim listama nezavisno od pisma: podaci su latinicom, a korisnik u ćiriličkom režimu
// kuca ćirilicom (i obrnuto). Upit i opcije se svode na latinicu bez dijakritika prije poređenja.
const CYR: Record<string, string> = {
  а: "a", б: "b", в: "v", г: "g", д: "d", ђ: "dj", е: "e", ж: "z", з: "z", и: "i", ј: "j", к: "k", л: "l", љ: "lj",
  м: "m", н: "n", њ: "nj", о: "o", п: "p", р: "r", с: "s", т: "t", ћ: "c", у: "u", ф: "f", х: "h", ц: "c", ч: "c",
  џ: "dz", ш: "s",
};

export function searchKey(s: string): string {
  return (s || "").toLowerCase()
    .replace(/[а-яђјљњћџ]/g, (ch) => CYR[ch] ?? ch)
    .replace(/đ/g, "dj").replace(/dž/g, "dz")
    .normalize("NFD").replace(/[̀-ͯ]/g, "");
}

export const scriptAgnosticFilter: OptionsFilter = ({ options, search, limit }) => {
  const q = searchKey(search.trim());
  const out: ComboboxParsedItem[] = [];
  for (const o of options) {
    if (out.length >= limit) break;
    if ("group" in o) {
      const items = scriptAgnosticFilter({ options: o.items, search, limit: limit - out.length }) as ComboboxItem[];
      if (items.length) out.push({ group: o.group, items });
    } else if (!q || searchKey(o.label).includes(q)) {
      out.push(o);
    }
  }
  return out;
};
